<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                :class="mode ? 'content__titleday' : 'content__titlenight'"
                class="content-title d-flex align-center mr-2"
              >
                {{ $t("message.operation") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    :class="mode ? 'input__day' : 'input__night'"
                    v-model="filterForm.search"
                    :icon="'el-icon-search'"
                    class="mr-2"
                  ></crm-input>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="flex-style text-right">
            <div class="ml-2" style="float: right">
              <crm-create-and-column-settings
                :permission="$options.name"
                @c-create="drawerCreate = true"
                :class="mode ? 'button__settingsday' : 'button__settingsnight'"
                :columns="columns"
                @c-change="updateColumn"
                :v_can_create="'operations.create'"
              >
              </crm-create-and-column-settings>
            </div>

            <export-excel
              v-can="'operations.excels'"
              class="btn excel_btn"
              style="display:inline-flex"
              :data="list"
              @fetch="controlExcelData()"
              :fields="excel_fields"
              :worksheet="$t('message.operation')"
              :name="$t('message.operation')"
            >
              <el-button size="mini">
                <i class="el-icon-document-delete"></i>
                {{ $t("message.excel") }}
              </el-button>
            </export-excel>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->
      <div class="card-table-header table-crm-smart">
        <table
          class="table-my-code table-bordered"
          v-loading="loadingData"
          :class="mode ? 'table__myday' : 'table__mynight'"
        >
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>
              <th v-if="columns.car_number.show">
                {{ columns.car_number.title }}
              </th>
              <th v-if="columns.car_model.show">
                {{ columns.car_model.title }}
              </th>
              <th v-if="columns.car_color.show">
                {{ columns.car_color.title }}
              </th>
              <th v-if="columns.driver.show">
                {{ columns.driver.title }}
              </th>
              <th v-if="columns.reason.show">
                {{ columns.reason.title }}
              </th>
              <th v-if="columns.comment.show">
                {{ columns.comment.title }}
              </th>
              <th v-if="columns.managed_task.show">
                {{ columns.managed_task.title }}
              </th>
              <th v-if="columns.left_date_time.show">
                {{ columns.left_date_time.title }}
              </th>
              <!-- <th v-if="columns.left_time.show">
                {{ columns.left_time.title }}
              </th> -->
              <th v-if="columns.arrival_date_time.show">
                {{ columns.arrival_date_time.title }}
              </th>
              <!-- <th v-if="columns.arrival_time.show">
                {{ columns.arrival_time.title }}
              </th> -->
              <th v-if="columns.total_spent_time.show">
                {{ columns.total_spent_time.title }}
              </th>
              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>
              <th v-if="columns.updated_at.show">
                {{ columns.updated_at.title }}
              </th>
              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>
            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  v-model="filterForm.id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>
              <th v-if="columns.car_number.show">
                <crm-input
                  :inputValue="filterForm.car_number"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.car_number.title"
                  v-model="filterForm.car_number"
                  size="mini"
                ></crm-input>
              </th>
              <th v-if="columns.car_model.show">
                <select-guest-car-model
                  :size="'mini'"
                  :id="filterForm.guest_car_model_id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.guest_car_model_id"
                ></select-guest-car-model>
              </th>
              <th v-if="columns.car_color.show">
                <crm-input
                  :inputValue="filterForm.car_color"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.car_color.title"
                  v-model="filterForm.car_color"
                  size="mini"
                ></crm-input>
              </th>
              <th v-if="columns.driver.show">
                <crm-input
                  :inputValue="filterForm.driver"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.driver.title"
                  v-model="filterForm.driver"
                  size="mini"
                ></crm-input>
              </th>
              <th v-if="columns.reason.show">
                <el-select
                  v-model="filterForm.reason_id"
                  :placeholder="$t('message.reason')"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  class="w-100"
                  :size="'small'"
                  filterable
                  clearable
                  popper-class="my-data-khan"
                >
                  <el-option
                    v-for="(reason, index) in reasons"
                    :key="'guestreason-' + index"
                    :label="reason.name"
                    :value="reason.id"
                  ></el-option>
                </el-select>
              </th>
              <th v-if="columns.comment.show">
                <crm-input
                  :inputValue="filterForm.comment"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.comment.title"
                  v-model="filterForm.comment"
                  size="mini"
                ></crm-input>
              </th>
              <th v-if="columns.managed_task.show">
                <crm-input
                  :inputValue="filterForm.managed_task"
                  :placeholder="columns.managed_task.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.managed_task"
                  size="mini"
                ></crm-input>
              </th>
              <th v-if="columns.left_date_time.show">
                <crm-date-picker
                  :placeholder="columns.left_date_time.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.left_date"
                  size="mini"
                >
                </crm-date-picker>
              </th>
              <!-- <th v-if="columns.left_time.show">
                <el-time-picker
                  value-format="HH:mm:ss"
                  format="HH:mm:ss"
                  :placeholder="columns.left_time.title"
                  v-model="filterForm.left_time"
                  style="width: 100%"
                  size="mini"
                ></el-time-picker>
              </th> -->
              <th v-if="columns.arrival_date_time.show">
                <crm-date-picker
                  :placeholder="columns.arrival_date_time.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.arrival_date"
                  size="mini"
                >
                </crm-date-picker>
              </th>
              <!-- <th v-if="columns.arrival_time.show">
                <el-time-picker
                  value-format="HH:mm:ss"
                  format="HH:mm:ss"
                  :placeholder="columns.arrival_time.title"
                  v-model="filterForm.arrival_time"
                  style="width: 100%"
                  size="mini"
                ></el-time-picker>
              </th> -->
              <th v-if="columns.total_spent_time.show">
                <crm-input
                  :inputValue="filterForm.total_spent_time"
                  :placeholder="columns.total_spent_time.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.total_spent_time"
                  size="mini"
                ></crm-input>
              </th>

              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                  size="mini"
                >
                </crm-date-picker>
              </th>

              <th v-if="columns.updated_at.show">
                <crm-date-picker
                  :placeholder="columns.updated_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.updated_at"
                  size="mini"
                >
                </crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="operation in list"
              :key="operation.id"
              class="cursor-pointer"
            >
              <td v-if="columns.id.show">{{ operation.id }}</td>
              <td v-if="columns.car_number.show">
                {{ operation.transport ? operation.transport.number : "" }}
              </td>
              <td v-if="columns.car_model.show">
                {{ operation.transport ? operation.transport.model.model : "" }}
              </td>
              <td v-if="columns.car_color.show">
                {{ operation.transport ? operation.transport.color : "" }}
              </td>
              <td v-if="columns.driver.show">
                {{ operation.driver }}
              </td>
              <td v-if="columns.reason.show">
                {{ operation.reason ? operation.reason.name : "" }}
              </td>
              <td v-if="columns.comment.show">
                {{ operation.comment }}
              </td>
              <td v-if="columns.managed_task.show">
                {{ operation.managed_task }}
              </td>
              <td v-if="columns.left_date_time.show">
                {{ operation.left_date }} {{ operation.left_time }}
              </td>
              <!-- <td v-if="columns.left_time.show">
                {{ operation.left_time }}
              </td> -->
              <td v-if="columns.arrival_date_time.show">
                {{ operation.arrival_date }}
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-time"
                  round
                  @click="updateArrivals(operation)"
                >
                  {{ operation.arrival_time }}
                </el-button>
              </td>

              <!-- <td v-if="columns.arrival_time.show">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-time"
                  round
                  @click="updateArrivals(operation)"
                >
                  {{ operation.arrival_time }}
                </el-button>
              </td> -->
              <td v-if="columns.total_spent_time.show">
                {{ operation.total_spent_time }}
              </td>
              <td v-if="columns.created_at.show">
                {{ operation.created_at }}
              </td>
              <td v-if="columns.updated_at.show">
                {{ operation.updated_at }}
              </td>
              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="operation"
                  :actions="actions"
                  :permissionShow="'operations.update'"
                  :permissionDestroy="'operations.destroy'"
                  @edit="edit"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>

      <div class="app-modal app-modal__full">
        <el-drawer
          :with-header="false"
          :visible.sync="drawerCreate"
          size="70%"
          ref="drawerCreate"
          @opened="drawerOpened('drawerCreateChild')"
          @closed="drawerClosed('drawerCreateChild')"
        >
          <crm-create
            ref="drawerCreateChild"
            drawer="drawerCreate"
          ></crm-create>
        </el-drawer>

        <el-drawer
          :with-header="false"
          :visible.sync="drawerUpdate"
          size="70%"
          ref="drawerUpdate"
          @opened="drawerOpened('drawerUpdateChild')"
          @closed="drawerClosed('drawerUpdateChild')"
        >
          <crm-update
            :selectedItem="selectedItem"
            ref="drawerUpdateChild"
            drawer="drawerUpdate"
          ></crm-update>
        </el-drawer>
      </div>
      <el-dialog
        title="Время отправления"
        :visible.sync="openDialog"
        width="30%"
        center
        @open="elDialogOpened()"
        :class="mode ? 'dialog__myday' : 'dialog__mynight'"
      >
        <el-form ref="form" status-icon :model="form" :rules="arrivalRules">
          <span>
            <span
              :class="mode ? 'text__day2' : 'text__night2'"
              class="input--label d-block mb-2"
            >
              {{ $t("message.arrival_date") }}
            </span>
            <el-form-item prop="arrival_date" size="medium">
              <crm-date-picker
                :placeholder="$t('message.arrival_date')"
                :date="form.arrival_date"
                v-model="form.arrival_date"
                style="width: 100%"
                :class="mode ? 'input__day' : 'input__night'"
              ></crm-date-picker>
            </el-form-item>
          </span>
          <span>
            <span
              :class="mode ? 'text__day2' : 'text__night2'"
              class="input--label d-block mb-2"
            >
              {{ $t("message.arrival_time") }}
            </span>
            <el-form-item prop="arrival_time" size="medium">
              <el-time-picker
                :placeholder="$t('message.arrival_time')"
                v-model="form.arrival_time"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                style="width: 100%"
                size="mini"
                :class="mode ? 'input__day' : 'input__night'"
              ></el-time-picker>
            </el-form-item>
          </span>
          <span>
            <span
              :class="mode ? 'text__day2' : 'text__night2'"
              class="input--label d-block mb-2"
            >
              {{ columns.managed_task.title }}
            </span>
            <el-form-item prop="managed_task" size="medium">
              <crm-input
                type="textarea"
                :inputValue="form.managed_task"
                v-model="form.managed_task"
                :placeholder="$t('message.managed_task')"
                :class="mode ? 'input__day' : 'input__night'"
              ></crm-input>
            </el-form-item>
          </span>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateArrivalTimes()">
            Сохранить
          </el-button>
          <el-button type="warning" @click="closeElDialog()">
            Закрыть
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import selectStaff from "@/components/filters/inventory/select-staff";
import selectGuestCarModel from "@/components/filters/inventory/select-guest-car-model";
import list from "@/utils/mixins/list";
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  mixins: [list],
  name: "OperationController",
  components: {
    CrmCreate,
    CrmUpdate,
    selectStaff,
    selectGuestCarModel
  },
  data() {
    return {
      drawer: false,
      openDialog: false,
      currentPage2: 5,
      checkList: [],
      form: {
        arrival_date: null,
        arrival_time: null,
        managed_task: ""
      },
      selectedOperator: null,
      loadingButton: false,
      arrivalRules: {
        arrival_date: [
          {
            required: true,
            message: "Пожалуйста, введите название ",
            trigger: "change"
          }
        ],
        arrival_time: [
          {
            required: true,
            message: "Пожалуйста, введите название ",
            trigger: "change"
          }
        ],
        managed_task: [
          {
            required: true,
            message: "Пожалуйста, введите название ",
            trigger: "change"
          }
        ]
      }
    };
  },
  watch: {
    "form.arrival_date": {
      handler: function() {},
      immediate: true,
      deep: true
    },
    "form.arrival_time": {
      handler: function() {},
      immediate: true,
      deep: true
    },
    "form.managed_task": {
      handler: function() {},
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.reasonsAction();
  },
  computed: {
    ...mapGetters({
      list: "operation/list",
      columns: "operation/columns",
      pagination: "operation/pagination",
      statues: "operation/statues",
      filter: "operation/filter",
      sort: "operation/sort",
      reasons: "operation/reasons",
      mode: "MODE"
    }),
    actions: function() {
      return ["delete", "edit"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "operation/index",
      setPagination: "operation/setPagination",
      updateSort: "operation/updateSort",
      updateFilter: "operation/updateFilter",
      updateColumn: "operation/updateColumn",
      updatePagination: "operation/updatePagination",
      show: "operation/show",
      empty: "operation/empty",
      delete: "operation/destroy",
      refreshData: "operation/refreshData",
      updateDates: "operation/updateArrivalDateTimes",
      reasonsAction: "operation/reasons"
    }),
    elDialogOpened() {
      if (
        this.selectedOperator.arrival_date == null &&
        this.selectedOperator.arrival_time == null
      ) {
        this.form.arrival_date = moment().format("DD.MM.YYYY");
        this.form.arrival_time = moment().format("HH:mm:ss");
      } else {
        this.form.arrival_date = this.selectedOperator.arrival_date;
        this.form.arrival_time = this.selectedOperator.arrival_time;
      }
      this.form.managed_task = this.selectedOperator.managed_task;
    },
    updateArrivals(operator) {
      this.selectedOperator = operator;
      this.form.id = operator.id;
      this.openDialog = true;
    },
    updateArrivalTimes() {
      this.$refs["form"].validate(valid => {
        if (valid && !this.loadingButton) {
          this.loadingButton = true;
          this.updateDates(this.form)
            .then(res => {
              this.$alert(res);
              if (res.status == 201) {
                this.closeElDialog();
              }
              this.fetchData();
              this.afterFetchData();
              this.loadingButton = false;
            })
            .catch(err => {
              this.loadingButton = false;
              this.$alert(err);
            });
        }
      });
    },
    closeElDialog() {
      this.openDialog = false;
      this.form = JSON.parse(
        JSON.stringify({
          arrival_date: null,
          arrival_time: null,
          managed_task: ""
        })
      );
    },
    destroy(model) {
      this.delete(model.id)
        .then(res => {
          this.$alert(res);
          this.fetchData();
        })
        .catch(err => {
          this.$alert(err);
        });
    },
    controlExcelData() {
      this.excel_fields = {};
      for (let key in this.columns) {
        if (this.columns.hasOwnProperty(key)) {
          let column = this.columns[key];
          if (column.show && column.column != "settings") {
            switch (column.column) {
              case "car_number":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return item.transport ? item.transport.number : "";
                  }
                };
                break;
              case "car_model":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return item.transport ? item.transport.model.model : "";
                  }
                };
                break;
              case "car_color":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return item.transport ? item.transport.color : "";
                  }
                };
                break;
              case "reason":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return item.reason ? item.reason.name : "";
                  }
                };
                break;
              case "left_date_time":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return (
                      (item.left_date ? item.left_date : "") +
                      " " +
                      (item.left_time ? item.left_time : "")
                    );
                  }
                };
                break;
              case "arrival_date_time":
                this.excel_fields[column.title] = {
                  callback: item => {
                    return (
                      (item.arrival_date ? item.arrival_date : "") +
                      " " +
                      (item.arrival_time ? item.arrival_time : "")
                    );
                  }
                };
                break;
              default:
                this.excel_fields[column.title] = column.column;
                break;
            }
          }
        }
      }
    }
  }
};
</script>
